export default __webpack_public_path__ + "static/media/basement.72f73232.jpg";